import React from 'react'


export const SafeareaBox = (props) => (
    <div className="box safearea-info">
        <div className="safearea-img-container">
            <img className="safearea-icon" src="/assets/images/mail/area-cliente.png" alt="Área do cliente" />

        </div>
        <div className="safearea-text-container">
            <span className="safearea-text">
                Acompanhe o status
                <br />
                &nbsp;do seu pedido na nossa&nbsp;
                <br />
                <a href="/area-do-cliente/" className="safearea-link">Área do Cliente</a>.
            </span>
        </div>
    </div>
)

export default SafeareaBox;



// WEBPACK FOOTER //
// ./src/components/purchase_status/SafeareaBox.jsx